import { createSlice } from '@reduxjs/toolkit'

const userProfileSlice = createSlice({
    name: 'user-profile',
    initialState: { error: null, loading: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        logout() {},
    },
})

const { actions, reducer } = userProfileSlice

export const { setLoading, setError, logout } = actions

export default reducer
